import { EStorageKey } from 'common/const';

/* Сохранённая карта убрана (payment-buttons, R-9, O-11, O-15): токен и флаг с прошлых оплат
 *  больше не нужны и удаляются при загрузке страницы оплаты. Недоступное хранилище оплате
 *  не мешает: ключи удалятся при следующем визите. */
export const forgetSavedCard = (): void => {
  try {
    localStorage.removeItem(EStorageKey.PayspotToken);
    localStorage.removeItem(EStorageKey.SaveCard);
  } catch {
    // хранилище недоступно: читать ключи всё равно некому
  }
};
